import React from 'react';
import { GlobeHifiIcon } from '@applyboard/ui-icons';
import { InfoBoxItem } from "../InfoBoxItem";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var SourceItem = function SourceItem(_ref) {
  var sourceUrl = _ref.sourceUrl;
  return _jsx(InfoBoxItem, {
    icon: _jsx(GlobeHifiIcon, {
      contrast: "mid",
      intent: "secondary"
    }),
    label: "Source",
    subLabel: sourceUrl ? 'website' : undefined,
    subLabelLinkUrl: sourceUrl || undefined
  });
};